export default __webpack_public_path__ + "materialicons.3146fcbfa119727b25783b92e09b8ba5.woff2";